<template>
  <DropdownHybrid
    v-model="isOpen"
    :sheet-title="t('component.add_button.title')"
  >
    <template #activator="{ props: activatorProps }">
      <BrandButton
        v-bind="{ ...activatorProps, ...$attrs }"
        variant="primary"
        size="large"
        class="pl-3"
      >
        <PhPlus class="text-h5 mr-3" />
        {{ t('cta.add') }}
      </BrandButton>
    </template>

    <v-list bg-color="neutral25" class="py-3">
      <v-list-item @click="onAddBookmark">
        <template #prepend>
          <PhBookmarkSimple class="text-h5 mr-3" />
        </template>
        <v-list-item-title class="text-neutral900 font-weight-medium">
          {{ t('component.add_button.add_bookmark') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="onAddNote">
        <template #prepend>
          <PhNote class="text-h5 mr-3" />
        </template>
        <v-list-item-title class="text-neutral900 font-weight-medium">
          {{ t('component.add_button.add_note') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="imageUploadsEnabled" @click="onAddFile">
        <template #prepend>
          <PhImage class="text-h5 mr-3" />
        </template>
        <v-list-item-title class="text-neutral900 font-weight-medium">
          {{ t('component.add_button.add_image') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </DropdownHybrid>
</template>

<script setup>
import { ref, computed, defineProps, defineOptions } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { PhPlus, PhBookmarkSimple, PhNote, PhImage } from '@phosphor-icons/vue'
import DropdownHybrid from '@/components/global/DropdownHybrid.vue'
import BrandButton from '@/components/global/brand/BrandButton.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  collectionId: {
    type: String,
    default: null,
  },
  referrer: {
    type: String,
    default: 'nav',
  },
})

const router = useRouter()
const store = useStore()
const { t } = useI18n()

const isOpen = ref(false)
// runtime feature flag (admin-toggled); the API has its own kill switch
const imageUploadsEnabled = computed(() => store.getters['features/ImageUploads'])

const addBookmarkUrl = computed(() => {
  const collectionParam = props.collectionId ? `&collectionId=${props.collectionId}` : ''
  return `/bookmarks/add?referrer=${props.referrer}${collectionParam}`
})

const addNoteUrl = computed(() => {
  const collectionParam = props.collectionId ? `&collectionId=${props.collectionId}` : ''
  return `/notes/add?referrer=${props.referrer}${collectionParam}`
})

const onAddBookmark = () => {
  isOpen.value = false
  router.push(addBookmarkUrl.value)
}

const onAddNote = () => {
  isOpen.value = false
  router.push(addNoteUrl.value)
}

const onAddFile = () => {
  isOpen.value = false
  const collectionParam = props.collectionId ? `&collectionId=${props.collectionId}` : ''
  router.push(`/files/add?referrer=${props.referrer}${collectionParam}`)
}
</script>
